module.exports = {"id":"202374","name":"Ernest Asante","rating":"71","photo":"./data/images/photos/0/202374.png","club":{"name":"FC Nordsjælland","logo":"./data/images/clubs/FCNordsjælland.png"},"positions":["AD","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ErnestAsante0.json
// module id = 1290
// module chunks = 0